var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sui-page-contents',[_c('sui-grid',{ref:"grid",attrs:{"columns":_vm.gridColumns0,"autoheight":false,"pageable":false,"autoShrink":true,"dataset":'dataset0',"initialPagesize":5,"filterable":false,"sortable":false,"multiselect":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }